const ASK_URL = "/api/assistant/ask";

function esc(v) { return String(v ?? "").replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;"); }

let container = null;
let loading = false;
let error = null;
let question = "";
let history = []; // raw Anthropic messages[] array, echoed back on each request to continue the conversation
let turns = []; // display-only: [{ role: "user"|"assistant", text }]

async function ask() {
  const q = question.trim();
  if (!q || loading) return;
  turns.push({ role: "user", text: q });
  question = "";
  loading = true;
  error = null;
  render();
  try {
    const r = await fetch(ASK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ question: q, history }),
    });
    const data = await r.json();
    if (!r.ok || !data.ok) throw new Error(data.error || `HTTP ${r.status}`);
    history = data.history;
    turns.push({ role: "assistant", text: data.answer });
  } catch (err) {
    error = err.message || String(err);
    turns.pop(); // drop the user turn so it can be retried instead of stacking a duplicate
    question = q;
  } finally {
    loading = false;
    render();
  }
}

function clearChat() {
  if (loading) return;
  history = [];
  turns = [];
  error = null;
  render();
}

function renderTurn(turn) {
  const isUser = turn.role === "user";
  return `
    <div style="display:flex;${isUser ? "justify-content:flex-end;" : ""}margin-bottom:8px;">
      <div style="max-width:85%;padding:7px 10px;border-radius:8px;white-space:pre-wrap;word-break:break-word;font-size:12px;line-height:1.4;
        ${isUser ? "background:rgba(56,189,248,0.16);color:#e2e8f0;" : "background:rgba(148,163,184,0.1);color:#e2e8f0;"}">
        ${esc(turn.text)}
      </div>
    </div>`;
}

function render() {
  if (!container) return;
  const active = container.contains(document.activeElement) ? document.activeElement : null;
  const focusId = active?.id || null;

  container.innerHTML = `
    <div style="border:1px solid rgba(148,163,184,0.18);border-radius:8px;overflow:hidden;display:flex;flex-direction:column;height:100%;min-height:360px;">
      <div style="display:flex;align-items:center;gap:8px;padding:7px 10px;background:rgba(2,6,23,0.5);border-bottom:1px solid rgba(148,163,184,0.12);">
        <span class="small" style="font-weight:600;flex:1;">ASSISTANT</span>
        <button id="asst-clear" class="btn" ${loading || !turns.length ? "disabled" : ""} style="font-size:10px;padding:2px 8px;">Clear</button>
      </div>
      <div id="asst-scroll" style="flex:1;overflow-y:auto;padding:10px;">
        ${turns.length
          ? turns.map(renderTurn).join("")
          : `<div class="small" style="color:var(--muted);">Ask about project data -- e.g. "how many travel lifts are in the entire slip inventory", "when was HTM data delivered", "how many different regions are in COW".</div>`}
        ${loading ? `<div class="small" style="color:var(--muted);padding:4px 0;">Thinking…</div>` : ""}
      </div>
      ${error ? `<div class="small" style="color:#ef4444;padding:0 10px 8px;">${esc(error)}</div>` : ""}
      <div style="display:flex;gap:6px;padding:8px 10px;border-top:1px solid rgba(148,163,184,0.12);">
        <input id="asst-input" type="text" placeholder="Ask a question…" value="${esc(question)}" ${loading ? "disabled" : ""} style="flex:1;" />
        <button id="asst-send" class="btn" ${loading ? "disabled" : ""}>Send</button>
      </div>
    </div>
  `;
  bindEvents();

  const scroll = container.querySelector("#asst-scroll");
  if (scroll) scroll.scrollTop = scroll.scrollHeight;

  if (focusId) {
    const toRefocus = container.querySelector(`#${focusId}`);
    if (toRefocus) toRefocus.focus();
  }
}

function bindEvents() {
  if (!container) return;
  const input = container.querySelector("#asst-input");
  input?.addEventListener("input", (e) => { question = e.target.value; });
  input?.addEventListener("keydown", (e) => {
    if (e.key === "Enter") { e.preventDefault(); ask(); }
  });
  container.querySelector("#asst-send")?.addEventListener("click", ask);
  container.querySelector("#asst-clear")?.addEventListener("click", clearChat);
}

export const assistantTool = {
  id: "assistant",
  name: "Assistant",
  init() {},
  destroy() { container = null; },
  renderPanel(_appRef, panelEl) {
    container = panelEl;
    render();
  },
};
